// Module
var code = "<div class=\"checkbox-weekday-select\"> <label class=\"display-block label__text\"> Days </label> <bm-checkbox-select items=\"vm.items\" selected=\"vm.selected\" on-change=\"vm.onChange\"></bm-checkbox-select> <span ng-if=\"vm.error\" class=\"inline-error has-error\">Select at least one weekday</span> </div> ";
// Exports
module.exports = code;